import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  service: {
    description: 'service filter option actionable pill',
    defaultMessage: '{appliedFiltersCount, plural, one {Service} other {(Multiple Services)}}',
    id: 'vmqSot',
  },
});
